import { render, staticRenderFns } from "./BeCardListPackage.vue?vue&type=template&id=3b601683&scoped=true"
import script from "./BeCardListPackage.vue?vue&type=script&lang=js"
export * from "./BeCardListPackage.vue?vue&type=script&lang=js"
import style0 from "./BeCardListPackage.vue?vue&type=style&index=0&id=3b601683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b601683",
  null
  
)

export default component.exports